// extracted by mini-css-extract-plugin
module.exports = {"titleFirst":"Landing_titleFirst__2Z3ey","graduation":"Landing_graduation__3JpvM"};